// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requiredRole }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  // Validate that both token and role exist and role is valid
  const validRoles = ["Admin", "Staff"];
  const isValidSession = token && role && validRoles.includes(role);

  // If user is not logged in or session is invalid → redirect to login
  if (!isValidSession) {
    // Clear invalid data
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("staffType");
    return <Navigate to="/login" replace />;
  }

  // If route is restricted by role → redirect back to dashboard
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise → allow access
  return children;
}
